<template>
  <li class="dropdown-item-group">
    <div
      v-if="divider"
      class="divider"
    />
    <ul>
      <li
        v-if="groupName"
        class="dropdown-item-group-header"
      >
        <span>{{ groupName }}</span>
      </li>
      <slot />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'AppDropdownItemGroup',
  props: {
    groupName: {
      type: String,
      default: null,
    },
    divider: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
